export function MinusSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor" {...props}>
      <path d="M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" />
    </svg>
  );
}
